import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { LoginResponse } from '../../models/loginResponse';
import { LoginPayload } from '../../models/loginPayload';
import { CommonResponse } from '../../models/commomResponse';
import { ForgotPayload, VerifyOtpResponse } from '../../models/forgotPayload';
import { ResetPasswordPayload } from '../../models/resetPasswordPayload';
import { VerifyOtpPayload } from '../../models/verifyOtpPayload';
import { ProfilePayload } from '../../models/profilePayload';
import { ChangePasswordPayload } from '../../models/changePasswordPayload';
import { AddressListResponse } from '../../models/AddressListResponse';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  profileDetails: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);

  private isOpenSubject = new BehaviorSubject<boolean>(false);

  isOpen$ = this.isOpenSubject.asObservable();

  resetTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  emailSubject: BehaviorSubject<ForgotPayload | null> =
    new BehaviorSubject<ForgotPayload | null>(null);

  constructor(private readonly http: HttpClient) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginAdmin(data: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${environment.base_url}login`, data)
      .pipe(map(res => res.data));
  }

  forgotPassword(data: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}forgotPassword`,
      data
    );
  }

  verifyOtp(data: VerifyOtpPayload): Observable<VerifyOtpResponse> {
    return this.http
      .post<{
        data: VerifyOtpResponse;
      }>(`${environment.base_url}verifyOtp`, data)
      .pipe(map(res => res.data));
  }

  resetPassword(data: ResetPasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}resetPassword`, data)
      .pipe(map(res => res));
  }

  getProfile(): Observable<LoginResponse> {
    return this.http
      .get<{ data: LoginResponse }>(`${environment.base_url}getProfile`)
      .pipe(map(res => res.data));
  }

  updateProfile(data: ProfilePayload): Observable<LoginResponse> {
    return this.http
      .put<{
        data: LoginResponse;
      }>(`${environment.base_url}updateProfile`, data)
      .pipe(map(res => res.data));
  }

  changePassword(data: ChangePasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}changePassword`, data)
      .pipe(map(res => res));
  }

  logout(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${environment.base_url}logout`);
  }

  addressList(): Observable<AddressListResponse> {
    return this.http
      .get<{ data: AddressListResponse }>(`${environment.base_url}province`)
      .pipe(map(res => res.data));
  }

  toggleSidebarView(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }
}
